import React from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faSearch } from '@fortawesome/free-solid-svg-icons';
import stockSymbols from '../stock-symbols';
import { connect } from 'react-redux';
import { getChartData } from '../store/stocks';
import { getSymbol } from '../utils';

class SearchBar extends React.Component {
  constructor() {
    super();
    this.state = {
      activeSuggestion: 0,
      filteredSuggestions: [],
      showSuggestions: false,
      userInput: '',
    };
    this.onChange = this.onChange.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  onChange(e) {
    const userInput = e.currentTarget.value;
    const filteredSuggestions = stockSymbols
      .filter((suggestion) => {
        return suggestion.toLowerCase().indexOf(userInput.toLowerCase()) === 0;
      })
      .slice(0, 10);

    this.setState({
      activeSuggestion: 0,
      filteredSuggestions,
      showSuggestions: true,
      userInput: e.currentTarget.value,
    });
  }

  async onClick(e) {
    this.setState({
      activeSuggestion: 0,
      filteredSuggestions: [],
      showSuggestions: false,
      userInput: e.currentTarget.innerText,
    });
    const symbol = getSymbol(e.target.innerText);
    await this.props.getChartData(symbol, 'ytd');
  }
  onKeyDown(e) {
    const { activeSuggestion, filteredSuggestions } = this.state;

    if (e.keyCode === 13) {
      this.setState({
        activeSuggestion: 0,
        showSuggestions: false,
        userInput: filteredSuggestions[activeSuggestion],
      });
    } else if (e.keyCode === 38) {
      if (activeSuggestion === 0) {
        return;
      }

      this.setState({ activeSuggestion: activeSuggestion - 1 });
    } else if (e.keyCode === 40) {
      if (activeSuggestion - 1 === filteredSuggestions.length) {
        return;
      }

      this.setState({ activeSuggestion: activeSuggestion + 1 });
    }
  }

  render() {
    const {
      onChange,
      onClick,
      onKeyDown,
      state: {
        activeSuggestion,
        filteredSuggestions,
        showSuggestions,
        userInput,
      },
    } = this;

    let suggestionsListComponent;

    if (showSuggestions && userInput) {
      if (filteredSuggestions.length) {
        suggestionsListComponent = (
          <ul className="suggestions">
            {filteredSuggestions.map((suggestion, index) => {
              let className;

              if (index === activeSuggestion) {
                className = 'suggestion-active';
              }

              return (
                <li className={className} key={suggestion} onClick={onClick}>
                  {suggestion}
                </li>
              );
            })}
          </ul>
        );
      } else {
        suggestionsListComponent = (
          <div className="no-suggestions">
            <em>No options</em>
          </div>
        );
      }
    }

    return (
      <div className="autocomplete-container">
        <div className="searchbar-container">
          <input
            type="text"
            placeholder="Symbol Lookup"
            onChange={onChange}
            onKeyDown={onKeyDown}
            value={userInput}
          />
          {/* <FontAwesomeIcon icon={faSearch} className="faSearch" /> */}
        </div>

        {suggestionsListComponent}
      </div>
    );
  }
}

const mapState = (state) => ({
  chartData: state.stocks.chartData,
});

const mapDispatch = (dispatch) => {
  return {
    getChartData: (symbol, option) => dispatch(getChartData(symbol, option)),
  };
};

export default connect(mapState, mapDispatch)(SearchBar);
